import React from 'react';
import logo from '../assets/logo.png';

function Logo({ size = 'md', clickable = true, withIcon = false }) {
  const sizes = {
    sm: { fontSize: 'var(--text-xl)', letterSpacing: '0.15em', icon: 26 },
    md: { fontSize: 'var(--text-3xl)', letterSpacing: '0.2em', icon: 34 },
    lg: { fontSize: 'var(--text-5xl)', letterSpacing: '0.25em', icon: 48 },
    xl: { fontSize: 'var(--text-6xl)', letterSpacing: '0.3em', icon: 60 },
  };

  const s = sizes[size] || sizes.md;

  const style = {
    fontSize: s.fontSize,
    fontWeight: 700,
    letterSpacing: s.letterSpacing,
    color: 'var(--color-text)',
    textDecoration: 'none',
    display: 'inline-block',
    cursor: clickable ? 'pointer' : 'default',
    userSelect: 'none',
  };

  const aiStyle = {
    color: 'var(--color-ai)',
    fontWeight: 800,
  };

  const iconStyle = {
    height: s.icon,
    width: s.icon,
    borderRadius: Math.round(s.icon / 4),
    verticalAlign: 'text-bottom',
    marginRight: '0.45em',
  };

  const content = (
    <>
      {withIcon && <img src={logo} alt="" style={iconStyle} />}
      T<span style={aiStyle}>AI</span>LOR
    </>
  );

  if (clickable) {
    return <a href="/" style={style}>{content}</a>;
  }

  return <span style={style}>{content}</span>;
}

export default Logo;
